export default __webpack_public_path__ + "static/media/home.d59b0042.png";